import { useToast } from '../../state-management/contexts/ToastContext'
import { getBottomPadding } from '../../utils/sessionStorage'
import { ToastBase } from './ToastBase'

export const GlobalToast = () => {
  const { currentLocalToastId, width, position } = useToast()

  return (
    <ToastBase
      key='global-toast'
      {...{ width: width ?? '' }}
      className={`${currentLocalToastId ? 'opacity-0' : 'opacity-100'} fixed z-50 ${position ?? ''} left-1/2 transform -translate-x-1/2`}
      style={position ? {} : { bottom: `${getBottomPadding() + 16}px` }}
    />
  )
}
